import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Route, Switch } from 'wouter';
import { AuthProvider, useAuth } from './auth.tsx';
import { Layout } from './components/Layout.tsx';
import { UpdateBanner } from './components/UpdateBanner.tsx';
import { BodyweightPage } from './pages/BodyweightPage.tsx';
import { ExerciseDetailPage } from './pages/ExerciseDetailPage.tsx';
import { ExercisesPage } from './pages/ExercisesPage.tsx';
import { InvitePage } from './pages/InvitePage.tsx';
import { LoginPage } from './pages/LoginPage.tsx';
import { PlanPage } from './pages/PlanPage.tsx';
import { PlanSetupPage } from './pages/PlanSetupPage.tsx';
import { ProgressPage } from './pages/ProgressPage.tsx';
import { SettingsPage } from './pages/SettingsPage.tsx';
import { TodayPage } from './pages/TodayPage.tsx';
import { WorkoutPage } from './pages/WorkoutPage.tsx';
// Display font for headings, bundled with the app (works offline; no third-party font requests).
import '@fontsource/audiowide/latin-400.css';
import './styles.css';

function Routes() {
  const { state } = useAuth();
  if (state.status === 'loading') return null;

  return (
    <Switch>
      <Route path="/invite/:token">{(params) => <InvitePage token={params.token} />}</Route>
      {state.status === 'signedOut' ? (
        <Route>
          <LoginPage />
        </Route>
      ) : (
        <Route>
          <Layout>
            <Switch>
              <Route path="/" component={TodayPage} />
              <Route path="/plan" component={PlanPage} />
              <Route path="/plan/setup" component={PlanSetupPage} />
              <Route path="/progress" component={ProgressPage} />
              <Route path="/exercises" component={ExercisesPage} />
              <Route path="/exercises/:id">{(params) => <ExerciseDetailPage id={params.id} />}</Route>
              <Route path="/workouts/:id">{(params) => <WorkoutPage id={params.id} />}</Route>
              <Route path="/bodyweight" component={BodyweightPage} />
              <Route path="/settings" component={SettingsPage} />
              <Route>
                <h1>Not found</h1>
              </Route>
            </Switch>
          </Layout>
        </Route>
      )}
    </Switch>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <Routes />
      <UpdateBanner />
    </AuthProvider>
  </StrictMode>,
);
